import { Injectable } from '@angular/core';

/**
 * Canonical in-memory bearer-token store (no localStorage), shared via
 * `continity-shared-shell`: the refresh token lives in an HttpOnly cookie, the
 * short-lived access token only in memory. Superset of the former per-app copies
 * — also exposes `getTokenExpiryTime()` for refresh-timer consumers (ADO #1522).
 */
@Injectable({ providedIn: 'root' })
export class TokenStorageService {
  private accessToken: string | null = null;
  private tokenExpiration = 0;

  getToken(): string | null {
    if (this.accessToken && Date.now() < this.tokenExpiration) {
      return this.accessToken;
    }
    return null;
  }

  setToken(token: string, expiresIn: number): void {
    this.accessToken = token;
    this.tokenExpiration = Date.now() + expiresIn * 1000;
  }

  clearToken(): void {
    this.accessToken = null;
    this.tokenExpiration = 0;
  }

  get isTokenValid(): boolean {
    return !!this.getToken();
  }

  /** Absolute expiry timestamp (ms epoch) of the current token, or null if none.
   *  Used by refresh-timer consumers (e.g. the main portal's TokenService). */
  getTokenExpiryTime(): number | null {
    return this.getToken() ? this.tokenExpiration : null;
  }
}
